import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const MyContract = lazy(() => import("@/pages/MyContract"));

export const Route = createFileRoute("/mitt-elpris")({
  head: () => seoHead("/mitt-elpris"),
  component: () => <MyContract />,
});
